<template>
    <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <div class="margin-top-30">
            <tl-tabs :tabs="tabs" :customclass="true">
                <tl-tab>
                    <upload-fbp-claims>
                    </upload-fbp-claims>
                </tl-tab>
                <tl-tab>
                    <fbp-claim-history>
                    </fbp-claim-history>
                </tl-tab>
            </tl-tabs>
        </div>

    </div>
</template>

<script>


    import uploadFbpClaims from './uploadFbpClaims.vue';
    import fbpClaimHistory from './fbpClaimHistory.vue';
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'

    export default {
        name: 'FbpClaimBills',
        components: {
            uploadFbpClaims,
            fbpClaimHistory,
        },
        data() {
            return {
                breadcrumbList:[
              {
                name: "Payroll",
                url: `/dashboard/${this.$route.params.entity_index}/payroll`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
              },
              {
                name: "FBP Claims",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbp_claim`
              }
        ],
                tabs: [{
                    header: "Upload FBP Claims",
                }, {
                    header: "FBP Claim History",
                }],
            }
        },

        mounted() {

        },

        methods: {
            ...mapActions({
            }),

            routeToMainStep() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/payroll`
                });
            },
            routeToSubStep() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
                });
            },
        },


    }
</script>

<style lang="scss" scoped>
    .margin-top-30 {
        margin-top: 30px;
    }

    .content {
        margin-left: 20px;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .subtitle {
        width: 316px;
        height: 15px;
        font-family: Montserrat;
        font-size: 12px;
        color: #646464;
    }

    .searchsort {
        display: flex;
        align-items: center;
        width: 100%;
        padding-right: 10px;
        .sorttext {
            text-align: center;
            line-height: 30px;
            color: #726f75;
            padding: 0px 0px 0px 10px;
            margin-left: auto;
        }
    }

    .tabs .tab-container {
        padding-top: 30px;
        padding-left: 0px;
    }
</style>